import AppManagementRequest from './AppManagementRequest';

export default class ApprovalsRequest extends AppManagementRequest {
	//param @app : AppManagementModel
	//param @createdBy: user profile from useIdentify()
	//param @approvalFlowType: string (one of: 'SingleLevel', 'MultiLevel', 'None')
	//param @recipients : string (';' delimited string of email addresses)
	//param @applicationExtensions : BaseApplication_Extension[]
	constructor(
		app,
		createdBy,
		approvalFlowType,
		reviewers = null,
		applicationExtensions = null,
		requirementNumber
	) {
		super(app, createdBy, requirementNumber);
		this.approvalFlowType = approvalFlowType;
		this.reviewers = reviewers;
		this.applicationExtensions = applicationExtensions;
	}
}
